import { AccountState } from '@account-users/account/models';
import { createReducer, on } from '@ngrx/store';

import { LicenseActions } from './actions';
import {
  licenseAdapter,
  licenseAdapterInitialState,
  LicenseState,
} from './state';

const getLicensesReducer = [
  on(LicenseActions.GetLicenses.request, (state: LicenseState) => ({
    ...state,
    isLoading: true,
  })),
  on(LicenseActions.GetLicenses.success, (state: LicenseState, { items }) =>
    licenseAdapter.setAll(items, { ...state, isLoading: false }),
  ),
];

const addLicenseReducer = [
  on(
    LicenseActions.AddLicense.request,
    (state: LicenseState, { licenseCode }) =>
      licenseAdapter.updateOne(
        {
          id: licenseCode,
          changes: { state: AccountState.Pending, enabled: true },
        },
        state,
      ),
  ),
  on(LicenseActions.AddLicense.success, (state: LicenseState, { update }) =>
    licenseAdapter.updateOne(update, state),
  ),
];

const updateLicenseReducer = [
  on(LicenseActions.UpdateLicense.success, (state: LicenseState, { updates }) =>
    licenseAdapter.updateMany(updates, state),
  ),
];

const removeLicenseReducer = [
  on(
    LicenseActions.RemoveLicense.request,
    (state: LicenseState, { licenseCode }) =>
      licenseAdapter.updateOne(
        { id: licenseCode, changes: { enabled: false } },
        state,
      ),
  ),
];

const failureReducer = [
  on(LicenseActions.failure, (state: LicenseState, { errorMessage }) => ({
    ...state,
    isLoading: false,
    errorMessage,
  })),
];

export const LicenseReducer = createReducer<LicenseState>(
  licenseAdapterInitialState,
  ...getLicensesReducer,
  ...addLicenseReducer,
  ...updateLicenseReducer,
  ...removeLicenseReducer,
  ...failureReducer,
);
